/* @flow */
import idx from 'idx';
import * as React from 'react';
import groupBy from 'lodash/groupBy';
import { graphql } from 'react-apollo';
import GET_ADMIN_INTEGRATIONS from 'admin/queries/getAdminIntegrations.gql';

type Props = {
  data: *,
  children: Function,
  fetchPolicy?: ?string,
  organizationUUID: string,
};

class AdminIntegrationsContainer extends React.Component<Props, {}> {
  getIntegrationsByType() {
    const integrations = idx(this.props, _ => _.data.adminPossibleIntegrations) || [];
    return groupBy(integrations, integration => integration.__typename);
  }

  render() {
    const integrationsByType = this.getIntegrationsByType();

    return this.props.children({
      adminIntegrations: integrationsByType.AdminIntegration || [],
      partnerIntegrations: integrationsByType.PartnerIntegration || [],
    });
  }
}

const withAdminIntegrations = graphql(GET_ADMIN_INTEGRATIONS, {
  options: ({ organizationUUID, fetchPolicy }) => ({
    variables: { organizationUUID },
    fetchPolicy,
  }),
});

export default withAdminIntegrations(AdminIntegrationsContainer);
